<template>
    <form @submit.prevent="login">
        <div class="main">
            <div class="form-row">
                <div class="form-field">
                    <label for="reg-fio-input">Телефон:</label>
                    <input id="reg-fio-input" v-model.trim="phone" type="tel" required />
                </div>
                <div class="form-field">
                    <label for="reg-phone-input">Пароль:</label>
                    <input id="reg-phone-input" v-model="password" type="password" required />
                </div>
                <div class="form-field">
                    <button class="submit" :disabled="!phone || !password">
                        Войти
                    </button>
                </div>
                <div class="form-field">
                    <router-link tag="button" to="/forgot-password">
                        Забыли пароль?
                    </router-link>
                </div>
            </div>
            <div class="form-row" v-if="info">{{ info }}</div>
        </div>
    </form>
</template>

<style>
    .login {
        display: flex;
        flex-direction: column;
        width: 300px;
        padding: 10px;
    }
</style>

<script>
    export default {
        name: "login",
        data() {
            return {
                info: null,
                phone: null,
                password: null
            };
        },
        computed: {
            auth: function () {
                return this.$store.getters["auth/isAuthenticated"];
            }
        },
        methods: {
            login: function () {
                const {password, phone} = this;
                let data = {
                    password: password,
                    phone: phone
                };
                this.$store
                    .dispatch("auth/authRequest", data)
                    .then(loginData => {
                        if (!loginData.notConfirm)
                            this.goToHome();
                    }).catch(res => {
                        alert(res);
                    });
            },
            goToHome: function () {
                this.$router.push("/");
            }
        },
        mounted() {
            if (this.auth) {
                this.goToHome();
            }
        }
    };
</script>
